import { render } from "./TabelaImc.vue?vue&type=template&id=b2a068b8"
import script from "./TabelaImc.vue?vue&type=script&lang=js"
export * from "./TabelaImc.vue?vue&type=script&lang=js"

import "./TabelaImc.vue?vue&type=style&index=0&id=b2a068b8&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__